import globalStyles from '../../styles/exported.module.scss';

export const BinIcon = ({ className, ...rest }: { className?: string } & Partial<HTMLOrSVGElement>) => (
  <svg
    {...(className && { className })}
    {...rest}
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g mask="url(#mask0_3185_58254)">
      <path
        d="M7.77451 21C7.21715 21 6.74002 20.8042 6.34311 20.4125C5.94621 20.0208 5.74775 19.55 5.74775 19V6H4.73438V4H9.80126V3H15.8815V4H20.9484V6H19.935V19C19.935 19.55 19.7366 20.0208 19.3397 20.4125C18.9428 20.8042 18.4656 21 17.9083 21H7.77451ZM17.9083 6H7.77451V19H17.9083V6ZM9.80126 17H11.828V8H9.80126V17ZM13.8548 17H15.8815V8H13.8548V17Z"
        fill={globalStyles.bdPrimaryNavy}
      />
    </g>
  </svg>
);
